import React from 'react'

import * as c from '../../../common'
import * as r from '../../../react-utils'

import { useParams } from 'react-router-dom'

import ContractLogo from '../../routes/customer-report/ContractLogo'
import Pad from '../Pad'
import { RoofClaimContext } from './RoofClaimContext'

//@ts-ignore
import styles from './RoofClaimingContractHeader.module.css'

export default React.memo(function RoofClaimingContractHeader() {
  const { customerID } = useParams<'customerID'>()
  const { locked, readOnly, isPDF } = React.useContext(RoofClaimContext)

  const { contractCompanyFull, shouldOfferCompanySelector } =
    r.useContractCompany(customerID!)

  return (
    <div className={styles['main-info']}>
      <div className={styles['logo']}>
        {shouldOfferCompanySelector ? (
          <ContractLogo
            size="m"
            readOnly={locked || readOnly || isPDF}
            isPDF={isPDF}
          />
        ) : (
          <img alt="Fortitude logo" src={contractorToLogo.ecohome} />
        )}
      </div>
      <Pad amt={30} row />
      <div className={styles[`info-ecohome`]}>
        {shouldOfferCompanySelector ? (
          <>
            <p className={styles['info-text']}>
              {contractCompanyFull.phoneNumber}
            </p>
            <p className={styles['info-text']}>
              Lic # {contractCompanyFull.roofingLicense}
            </p>
            <p className={styles['info-text']}>
              {contractCompanyFull.address1}
            </p>
            <p className={styles['info-text']}>
              {contractCompanyFull.address2}
            </p>
          </>
        ) : (
          c.RoofClaimingContractorHeaderText.ecohome.map((text, index) => (
            <p className={styles['info-text']} key={index}>
              {text}
            </p>
          ))
        )}
      </div>
    </div>
  )
})

const contractorToLogo: Record<c.RoofClaimingContractorCompany, string> = {
  ecohome: c.LOGO_BIG,
}
